"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _common = require("@scuf/common");

var _reactRouterDom = require("react-router-dom");

var _honeywellLogoRed = _interopRequireDefault(require("../../assets/honeywell-logo-red.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RegisterNewAccount = /*#__PURE__*/function (_Component) {
  _inherits(RegisterNewAccount, _Component);

  var _super = _createSuper(RegisterNewAccount);

  function RegisterNewAccount(props) {
    var _this;

    _classCallCheck(this, RegisterNewAccount);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderAddressTable", function () {
      return /*#__PURE__*/_react["default"].createElement(_common.Table, null, /*#__PURE__*/_react["default"].createElement(_common.Table.Header, null, /*#__PURE__*/_react["default"].createElement(_common.Table.HeaderCell, {
        content: "Region"
      }), /*#__PURE__*/_react["default"].createElement(_common.Table.HeaderCell, {
        content: "Email Address"
      })), /*#__PURE__*/_react["default"].createElement(_common.Table.Body, null, /*#__PURE__*/_react["default"].createElement(_common.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "US & Canada"), /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "VoiceCustomerServiceAmericas@Honeywell.com")), /*#__PURE__*/_react["default"].createElement(_common.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "EMEA"), /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "VoiceCustomerServiceEMEA@Honeywell.com")), /*#__PURE__*/_react["default"].createElement(_common.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "APAC"), /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "VoiceCustomerServiceAPAC@Honeywell.com")), /*#__PURE__*/_react["default"].createElement(_common.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "Mexico & LATAM"), /*#__PURE__*/_react["default"].createElement(_common.Table.Cell, null, "Orders.PPRLATAM@Honeywell.com"))));
    });

    _defineProperty(_assertThisInitialized(_this), "getSubject", function () {
      return 'Partner Tools Portal -- New Account';
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Please include the following information in the body of the email:", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Email"), /*#__PURE__*/_react["default"].createElement("li", null, "First Name"), /*#__PURE__*/_react["default"].createElement("li", null, "Last Name"), /*#__PURE__*/_react["default"].createElement("li", null, "Organization"), /*#__PURE__*/_react["default"].createElement("li", null, "Tools to access (Voice Application Conversion Tool and/or Task Converstion Tool)")), /*#__PURE__*/_react["default"].createElement("br", null), "You will receive an email with instructions on how to login to your new account.");
    });

    _this.state = {
      redirect: false
    };
    return _this;
  }

  _createClass(RegisterNewAccount, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var redirect = this.state.redirect;

      if (redirect) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
          to: "/login"
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 3,
        mWidth: 3,
        sWidth: 2,
        xsWidth: 0
      }), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 6,
        mWidth: 6,
        sWidth: 8,
        xsWidth: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Card, null, /*#__PURE__*/_react["default"].createElement(_common.Card.Header, {
        className: "reset-header"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: _honeywellLogoRed["default"],
        alt: "Honeywell Logo",
        className: "reset-logo"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "reset-title"
      }, "Register New Account")), /*#__PURE__*/_react["default"].createElement(_common.Card.Content, null, "By providing your information to set up an account you agree to Honeywell\u2019s", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.honeywell.com/us/en/terms-and-conditions",
        target: "_blank",
        rel: "noreferrer"
      }, "Terms & Conditions"), " and understand Honeywell will process your personal information in accordance with its ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.honeywell.com/us/en/privacy-statement",
        target: "_blank",
        rel: "noreferrer"
      }, "Privacy Statement"), ".", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), "To register a new account, please send an email with the following information to get started:", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("b", null, "To:"), "\xA0", this.renderAddressTable(), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("b", null, "Subject:"), "\xA0", this.getSubject(), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), this.renderContent()), /*#__PURE__*/_react["default"].createElement(_common.Card.Footer, null, /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "link",
        content: "Return to Login Page",
        onClick: function onClick() {
          _this2.setState({
            redirect: true
          });
        }
      })))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 3,
        mWidth: 3,
        sWidth: 2,
        xsWidth: 0
      })));
    }
  }]);

  return RegisterNewAccount;
}(_react.Component);

var _default = RegisterNewAccount;
exports["default"] = _default;